module.exports = __webpack_public_path__ + "img/login-3.83c6b893.png";